<template>
  <div class="reset-password-error">
    <riseup-header/>

    <lottie-player class="broken"
                   :src="JSON.stringify(require('@/assets/animations/broken.json'))"
                   :preserveAspectRatio="'xMidYMax'"
                   autoplay/>
    <div class="title">נתקלנו בבעיה באימות, אנחנו מטפלים בזה!</div>
    <span class="text">נעדכן אותך בווטסאפ ברגע שהבעיה תיפתר.
      </span>
  </div>
</template>

<script>

import Segment from '@/Segment';
import RiseupHeader from '../../../../base-components/app-header/RiseupHeader.vue';

export default {
  name: '2faResetPasswordError',
  async created() {
    Segment.trackUserGot('2faResetPasswordError');
  },
  components: {
    RiseupHeader,
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/mixins';
@import "~base-ui/src/scss/riseup-colors";

.reset-password-error {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-align: center;

  .broken {
    width: 220px;
    margin-top: 40px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 32px;
    padding: 0 30px;
  }

  .text {
    font-size: 18px;
    padding: 12px;
  }
}
</style>
